<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
        <div class="form-wrapper">
          <el-form
            :model="form"
            ref="ruleForm"
            class="flex flex-row w-full"
          >
          <div class="flex-1">

            <div class="lg:mb-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('certificates.type_extend')}}</label>
              <el-form-item prop="type">
                <base-el-select class="w-full" :options="tiposCertificado" v-model="form.type" filterable disabled @change="onChangeType" />
              </el-form-item>
            </div>

            <div class="lg:mb-2" v-if="role === 3">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.entity_name')}}</label>
              <div class="flex justify-between">
                <el-form-item prop="clienteId" class="w-full">
                  <base-el-select class="w-full" :options="clientes" v-model="form.clienteId" filterable disabled />
                </el-form-item>
                <base-button class="mb-1 ml-4" mode="primary" :text="$t('app.detail')"  @click.prevent.stop="goDetailClient" :loading="isGeneralLoading"/>
              </div>
            </div>
            <div>
              <div  class="lg:mb-2">
                <base-ro-input :label="$t('app.name')" :data="form.CommonName"/>
              </div>
              <div class="lg:mb-2">
                    <base-ro-input :label="$t('app.serial_number')" :data="form.SerialNumber"/>
                  </div>
              <div class="lg:mb-2">
                <div class="mandatory">
                  <base-ro-input :label="$t('certificates.expires_at')" :data="form.FechaCaducidad"/>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive
            mode="primary"
            :text="$t('trash.delete')"
            icon="check"
            @click="deleteCertificate()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('trash.restore')"
            icon="check"
            @click="restoreCertificate()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <Dialog
        :title="$t('certificates.delete_certificate')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center
      >
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template> 
      </Dialog>
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getCertificate } from '@/services/certificates/getCertificate'

import { Dialog } from 'element-ui'
import { getClients } from '@/services/clients/getClients'
import { deleteTrashCert } from '@/services/trash/deleteTrashCert'
import { restoreTrashCert } from '@/services/trash/restoreTrashCert'

export default {
  /* eslint-disable camelcase */
  name: 'detalle-papelera-certificado',
  components: {
    Dialog,
    DetailLayout
  },
  data: function () {
    return {
      loading: false,
      searchView: false,
      activeName: 'es',
      clientes: [],
      header: {
        title: i18n.t('trash.certificate_detail'),
        icon: 'certificates',
        breadcrumb: {},
        nav: [],
        url: 'trash/certificates'
      },
      file: {
        name: '',
        b64: ''
      },
      selectedCifs: [],
      cifHasCertif: false, // flag para indicar que se va a vincular un certificado a un cif que ya tiene otro certificado
      form: {
        type: 'pfx',
        CommonName: '',
        SerialNumber: '',
        FechaCaducidad: '',
        file: '',
        password: '',
        clienteId: '',
        user: '',
        pass: '',
        id: 0
      },
      showModal: false,
      processMessage: i18n.t('app.delete_permanent_current_confirmation', { entity: i18n.t('certificates.entity_name').toLowerCase() }),
    }
  },
  computed: {
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    idCliente: function () {
      return this.$route.params.idCliente
    },
    SerialNumber: function () {
      return this.$route.params.SerialNumber
    },
    tipoCertificado: function () {
      return this.$route.params.TipoCertificado
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    isAdmin: function () {
      return this.$store.getters['app/isAdmin']
    },
    tiposCertificado: function () {
      return this.$store.getters['config/TIPOS_CERT']
    },
  },
  created: async function () {
    const idCliente = this.idCliente
    const SerialNumber = this.SerialNumber
    const tipoCert = this.tipoCertificado
    const breadcrumbs = []
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
    }
    await this.downloadData(idCliente, SerialNumber, tipoCert)
    
    breadcrumbs.push({ path: 'trash/certificates', name: i18n.t('trash.header') })
    breadcrumbs.push({ path: 'trash/certificates', name: i18n.t('trash.certificates') })
    this.form.name = SerialNumber
    breadcrumbs.push({ path: '', name: this.form.CommonName })
    this.$store.commit('app/setheaderBreadCrumb', this.form.CommonName)

    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    goDetailClient () {
      const id = this.idCliente
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    deleteCertificate () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        const idCliente = this.idCliente
        const Serialnumber = this.SerialNumber
        const tipoCertificado = this.tipoCertificado
        payload.push({
          idCliente: idCliente,
          Serialnumber,
          tipoCertificado
        })
        const response = await deleteTrashCert(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    restoreCertificate: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        const idCliente = this.idCliente
        const Serialnumber = this.SerialNumber
        const tipoCertificado = this.tipoCertificado
        payload.push({
          idCliente: idCliente,
          Serialnumber,
          tipoCertificado
        })
        const response = await restoreTrashCert(payload)
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.goBack()
      }
    },
    onChangeType: function (value) {
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    goBack: function () {
      this.$router.push({ name: 'trash/certificates' })
    },
    downloadData: async function (idCliente, serial, tipoCertificado) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente,
          serial,
          tipoCertificado,
          borrado: true,
        }
        const data = await getCertificate(params)
        if (data.blnError === true) {
          this.doFeedback(`${data.msgError} [${data.codError}]`)
        } else {
          this.setCertificate(data.Certificado)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setCertificate: function (certificate) {
      this.form.SerialNumber = certificate.SerialNumber
      this.form.type = certificate.TipoCertificado
      this.form.CommonName = certificate.CommonName
      this.form.FechaCaducidad = i18n.d(certificate.FechaCaducidad, 'numeric_datetime', { date: '-', datetime: ' ' })
      this.form.clienteId = certificate.idCliente
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },
  }

}
</script>

<style scoped>

.el-upload-dragger {
    background-color: #fff;
    border: 1px
    dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

.file-selected {
  color: rgb(90, 90, 90);
  text-transform: uppercase;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

 .el-loading-parent--relative {
    position: relative !important; }

  .el-loading-parent--hidden {
    overflow: hidden !important; }

    div.el-loading-mask {
        background-color: rgba(6,13,46,.8);
    }

  .el-loading-mask {
    position: absolute;
    z-index: 2000;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s; }
    .el-loading-mask.is-fullscreen {
      position: fixed; }
      .el-loading-mask.is-fullscreen .el-loading-spinner {
        margin-top: -25px; }
        .el-loading-mask.is-fullscreen .el-loading-spinner .circular {
          height: 50px;
          width: 50px; }
    div.el-loading-mask .el-loading-spinner {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}
body.el-loading-parent--relative {
    position: inherit !important;
}
  .el-loading-spinner {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute; }
    .el-loading-spinner .el-loading-text {
      color: #00BBFF;
      margin: 3px 0;
      font-size: 14px; }
    .el-loading-spinner .circular {
      height: 42px;
      width: 42px;
      -webkit-animation: loading-rotate 2s linear infinite;
      animation: loading-rotate 2s linear infinite; }
    .el-loading-spinner .path {
      -webkit-animation: loading-dash 1.5s ease-in-out infinite;
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #00BBFF;
      stroke-linecap: round; }
    .el-loading-spinner i {
      color: #00BBFF; }

  .el-loading-fade-enter,
  .el-loading-fade-leave-active {
    opacity: 0; }
</style>

<style lang="sass" scoped>
</style>
